{
  "--color-primary": ["#0284C7", "#38BDF8"],
  "--color-primary-opacity": ["#0284C71E", "#38BDF81E"],
  "--color-primary-opacity-hover": ["#0284C740", "#38BDF840"],
  "--color-primary-tint": ["#0284c71a", "#38bdf81a"],
  "--color-primary-shade": ["#0369a1", "#0284c7"],
  "--color-background": ["#FFFFFF", "#0A1622"],
  "--color-background-compact-menu": ["#FFFFFFEE", "#0A1622DD"],
  "--color-web-app-browser": ["#FFFFFFEE", "#060D158F"],
  "--color-background-compact-menu-reactions": ["#FFFFFFFA", "#0A1622DD"],
  "--color-background-compact-menu-hover": ["#0284c714", "#38bdf822"],
  "--color-background-secondary": ["#F0F8FD", "#0E1E2D"],
  "--color-background-secondary-accent": ["#E1F1FA", "#14293D"],
  "--color-background-sidebar": ["#E7F3FA", "#0E1E2D"],
  "--color-background-own": ["#E0F2FE", "#075985"],
  "--color-background-own-apple": ["#D2EFFC", "#075985"],
  "--color-background-selected": ["#E0F2FE", "#16314A"],
  "--color-background-own-selected": ["#BAE6FD", "#0369A1"],
  "--color-chat-hover": ["#E8F4FA", "#132638"],
  "--color-chat-active": ["#0284C7", "#0369A1"],
  "--color-chat-active-greyed": ["#38BDF8", "#0284C7"],
  "--color-item-hover": ["#E8F4FA", "#132638"],
  "--color-item-active": ["#D8EEFA", "#18324A"],
  "--color-text": ["#0C1E2C", "#F0F9FF"],
  "--color-text-secondary": ["#567287", "#94A3B8"],
  "--color-icon-secondary": ["#567287", "#94A3B8"],
  "--color-text-secondary-apple": ["#64748B", "#94A3B8"],
  "--color-borders": ["#D1E5F2", "#1C364C"],
  "--color-borders-input": ["#C0DDEE", "#274966"],
  "--color-dividers": ["#D1E5F2", "#1C364C"],
  "--color-dividers-android": ["#E1EFF7", "#0E1E2D"],
  "--color-links": ["#0284C7", "#38BDF8"],
  "--color-gray": ["#B8D1E0", "#627D94"],
  "--color-list-icon": ["#8EAEC2", "#94A3B8"],
  "--color-default-shadow": ["#0c253b26", "#04090e9c"],
  "--color-light-shadow": ["#0c253b15", "#00000040"],
  "--color-active": ["#0284C7", "#38BDF8"],
  "--color-active-darker": ["#0369A1", "#0284C7"],
  "--color-green": ["#00C73E", "#00C73E"],
  "--color-green-darker": ["#00A734", "#00A734"],
  "--color-success": ["#00C73E", "#00C73E"],
  "--color-text-meta-colored": ["#0284C7", "#38BDF8"],
  "--color-reply-hover": ["#E8F4FA", "#132638"],
  "--color-reply-active": ["#D8EEFA", "#18324A"],
  "--color-reply-own-hover": ["#BAE6FD", "#0284C7"],
  "--color-reply-own-hover-apple": ["#BAE6FD", "#0284C7"],
  "--color-reply-own-active": ["#7DD3FC", "#0EA5E9"],
  "--color-reply-own-active-apple": ["#7DD3FC", "#0EA5E9"],
  "--color-accent-own": ["#0284C7", "#38BDF8"],
  "--color-message-meta-own": ["#0284C7DD", "#BAE6FD99"],
  "--color-own-links": ["#0284C7", "#7DD3FC"],
  "--color-code": ["#0369a1", "#38BDF8"],
  "--color-code-own": ["#0369A1", "#BAE6FD"],
  "--color-code-bg": ["#0284c714", "#00000080"],
  "--color-code-own-bg": ["#0284c714", "#00000050"],
  "--color-composer-button": ["#567287CC", "#94A3B8CC"],
  "--color-message-reaction": ["#E0F2FE", "#122637"],
  "--color-message-reaction-hover": ["#BAE6FD", "#19364F"],
  "--color-message-reaction-own": ["#BAE6FD", "#075985"],
  "--color-message-reaction-hover-own": ["#7DD3FC", "#0369A1"],
  "--color-message-reaction-chosen-hover": ["#0284C7", "#38BDF8"],
  "--color-message-reaction-chosen-hover-own": ["#0284C7", "#38BDF8"],
  "--color-message-non-contact": ["#E0F2FE", "#94A3B8"],
  "--color-voice-transcribe-button": ["#E0F2FE", "#122637"],
  "--color-voice-transcribe-button-own": ["#BAE6FD", "#075985"],
  "--color-topic-blue": ["#0284C7", "#38bdf8"],
  "--color-topic-yellow": ["#7F693B", "#ffd67e"],
  "--color-topic-violet": ["#8B5A96", "#cb86db"],
  "--color-topic-green": ["#0d9488", "#2dd4bf"],
  "--color-topic-rose": ["#9B576B", "#ff93b2"],
  "--color-topic-red": ["#EB6858", "#fb6f5f"],
  "--color-topic-grey": ["#567287", "#94A3B8"],
  "--color-forum-unread-topic-hover": ["#e8f4fa", "#132638"],
  "--color-forum-hover-unread-topic-hover": ["#d8eefa", "#18324a"],
  "--color-chat-username": ["#0284C7", "#38BDF8"],
  "--color-borders-read-story": ["#B8D1E0", "#627D94"],
  "--color-background-menu-separator": ["#0284c71a", "#ffffff1a"],
  "--color-hover-overlay": ["#0284c708", "#38bdf80c"],
  "--color-toast-background": ["#0c253bE6", "#04090eE6"]
}
